export function useMetaTags() {
  
  const updateMetaTags = (metaData) => {
    // Update title
    if (metaData.title) {
      document.title = metaData.title;
    }

    // Update or create meta tags
    const updateMetaTag = (name, property, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`) || 
                document.querySelector(`meta[property="${property}"]`);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (name) meta.setAttribute('name', name);
        if (property) meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    if (metaData.description) {
      updateMetaTag('description', null, metaData.description);
    }

    if (metaData.keywords) {
      updateMetaTag('keywords', null, metaData.keywords.join(', '));
    }

    // Open Graph tags
    if (metaData.title) {
      updateMetaTag(null, 'og:title', metaData.title);
    }

    if (metaData.description) {
      updateMetaTag(null, 'og:description', metaData.description);
    }

    if (metaData.url) {
      updateMetaTag(null, 'og:url', metaData.url);
    }

    if (metaData.image) {
      updateMetaTag(null, 'og:image', metaData.image);
    }

    updateMetaTag(null, 'og:type', metaData.type || 'article');

    // Twitter Card tags
    if (metaData.title) {
      updateMetaTag('twitter:title', null, metaData.title);
    }

    if (metaData.description) {
      updateMetaTag('twitter:description', null, metaData.description);
    }

    if (metaData.image) {
      updateMetaTag('twitter:image', null, metaData.image);
    }

    updateMetaTag('twitter:card', null, 'summary_large_image');
  };

  const generateCaseStudyMetaTags = (caseStudyData) => {
    return {
      title: `${caseStudyData.title} | IGNIS Case Study`,
      description: caseStudyData.description,
      keywords: caseStudyData.keywords || [],
      url: `https://www.ignis.co.uk${caseStudyData.path}/`,
      image: caseStudyData.featuredImage || 'https://ignis-vids.s3.eu-west-1.amazonaws.com/meta_poster.png',
      type: 'article'
    };
  };

  return {
    updateMetaTags,
    generateCaseStudyMetaTags
  };
}